<template>
  <div
    class="phone_nav_box"
    :class="[NavBar == 1 ? 'NarBarUlColor1' : 'NarBarUlColor2']"
  >
    <div class="title_" :class="[shouMenu ? 'active_menu' : '']">
      <div class="logo_">
                <img
         v-if="NavBar == 1"
        class="phone_logo0"
        src="../../../../assets/image/Logo/logo2.png"
        alt
      />
           <img
           class="phone_logo0"
       v-else

        src="../../../../assets/image/Logo/logo.png"
        alt
      />
        <img
          v-if="NavBar == 1"
          class="phone_logo1"
          src="@/assets/image/Logo/home_side_bar.png"
          alt
        />
        <img
          v-else
          class="phone_logo1"
          src="@/assets/image/Logo/logo1.png"
          alt
        />
        <img
          class="phone_logo2"
          src="@/assets/image/Logo/home_side_bar_sdg.png"
          alt
        />
      </div>
      <div
        class="menu"
        :class="[shouMenu ? 'menu-closeable' : '']"
        @click="openMenu()"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <!-- v-show="shouMenu" -->
    <transition name="sub-menu">
      <div class="iphone_nav_box" v-show="shouMenu">
        <ul class="iphone_nav_box_ul">
          <li class="dropdown">
            <div class="a_href">
              <a href="/">{{ $t("Nav.Menu.Home") }}</a>
            </div>
            <div class="a_href" @click="dropSDGsFun('Story')">
              <a>{{ $t("Nav.Menu.Story") }}</a>
              <i class="iconfont icon-xiangxia1"></i>
            </div>
            <ul class="secondLevel" v-show="sdgsNavList.indexOf('Story') > -1">
              <!-- <li @click="anchor(1)">
                <a>{{ $t("Nav.Menu.Featured") }}</a>
              </li> -->
              <li @click="anchor('/newslist?type=Society')">
                <a>{{ $t("Nav.Menu.Society") }}</a>
              </li>
              <li @click="anchor('/newslist?type=Technology')">
                <a>{{ $t("Nav.Menu.Science") }}</a>
              </li>
              <li @click="anchor('/newslist?type=Case')">
                <a>{{ $t("Nav.Menu.Practices") }}</a>
              </li>
            </ul>
          </li>
          <li class="dropdown" @click="tip()">
            <div class="a_href">
              <a>{{ $t("Nav.Menu.DataHub") }}</a>
            </div>
          </li>
          <li class="dropdown">
            <div class="a_href">
              <a href="/appMaket">{{ $t("Nav.Menu.AppsMarket") }}</a>
            </div>
          </li>
          <li class="dropdown">
            <div class="a_href" @click="dropSDGsFun('Knowledge')">
              <a>{{ $t("Nav.Menu.Knowledgebase") }}</a>
              <i class="iconfont icon-xiangxia1"></i>
            </div>
            <ul
              class="secondLevel"
              v-show="sdgsNavList.indexOf('Knowledge') > -1"
            >
              <li @click="tip()">
                <a>{{ $t("Nav.Menu.Indicators") }}</a>
              </li>
              <li @click="tip()">
                <a>{{ $t("Nav.Menu.Reports") }}</a>
              </li>
            </ul>
          </li>
          <li class="dropdown">
            <div class="a_href" @click="dropSDGsFun('About')">
              <a>{{ $t("Nav.Menu.AboutUs") }}</a>
              <i class="iconfont icon-xiangxia1"></i>
            </div>
            <ul class="secondLevel" v-show="sdgsNavList.indexOf('About') > -1">
              <li @click="anchor('/about')">
                <a>{{ $t("Nav.Menu.SDG") }}</a>
              </li>
              <li @click="anchor('/contact')">
                <a>{{ $t("Nav.Menu.Contact") }}</a>
              </li>
            </ul>
          </li>

          <li class="dropdown">
            <div class="a_href" @click="dropSDGsFun('Language')">
              <a>{{ $t("Nav.Menu.Language") }}</a>
              <i class="iconfont icon-xiangxia1"></i>
            </div>
            <ul
              class="secondLevel"
              v-show="sdgsNavList.indexOf('Language') > -1"
            >
              <li @click="languageFun('zh')">
                <a>{{ $t("Nav.Menu.ZH") }}</a>
              </li>
              <li @click="languageFun('en')" class="noBorder">
                <a>{{ $t("Nav.Menu.EN") }}</a>
              </li>
            </ul>
          </li>
          <!-- <li class="dropdown">
            <div class="a_href" style="border: none" @click="languageFun">
              {{ currentLanguage == "zh" ? "中文" : "EN" }}
            </div>
          </li> -->
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { mapMixin } from "@/util/mixin";
import bus from "@/bus";
export default {
  mixins: [mapMixin],
  data() {
    return {
      pageIndex: 1, //判断是不是首页
      activeIndex: 1,
      NavBar: 1,
      shouMenu: false,
      sdgsNavList: ["Home"],
      currentLanguage: "zh",
    };
  },

  mounted() {
    this.currentLanguage = localStorage.getItem("locale");
  },
  watch: {
    $route: {
      handler(to, from) {
        if (
          to.path == "/sdgsindicators" ||
          to.path == "/login" ||
          to.path == "/register" ||
          to.path == "/forget"
        ) {
          this.show = false;
        } else {
          this.show = true;
        }
        if (
          to.path == "/" ||
          // to.path == "/datahub" ||
          to.path == "/sdgsindicators" ||
          to.path == "/appMaket2"
        ) {
          this.pageIndex = 1;
          this.NavBar = 1; //判断是不是首页
          this.headWhite = false;
        } else {
          this.headWhite = true;
          this.pageIndex = 2;
          this.NavBar = 2;
        }
        this.shouMenu = false;
        this.openSDGs = false;
      },

      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  methods: {
    anchor(path) {
      this.$router.push(path);
    },
    // anchor(index) {
    //   this.$router.push('/')
    //   let targetOffsetTop = document.querySelector(
    //     `.anchor:nth-child(${index + 1})`
    //   ).offsetTop;
    //   // 获取当前 offsetTop
    //   let scrollTop =
    //     document.documentElement.scrollTop || document.body.scrollTop;
    //   const STEP = 70;
    //   if (scrollTop > targetOffsetTop) {
    //     // 往上滑
    //     smoothUp();
    //   } else {
    //     // 往下滑
    //     smoothDown();
    //   }
    //   function smoothDown() {
    //     // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
    //     if (scrollTop < targetOffsetTop) {
    //       // 如果和目标相差距离大于等于 STEP 就跳 STEP
    //       // 否则直接跳到目标点，目标是为了防止跳过了。
    //       if (targetOffsetTop - scrollTop >= STEP) {
    //         scrollTop += STEP;
    //       } else {
    //         scrollTop = targetOffsetTop;
    //       }
    //       document.body.scrollTop = scrollTop;
    //       document.documentElement.scrollTop = scrollTop;
    //       // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
    //       requestAnimationFrame(smoothDown);
    //     }
    //   }
    //   function smoothUp() {
    //     if (scrollTop > targetOffsetTop) {
    //       if (scrollTop - targetOffsetTop >= STEP) {
    //         scrollTop -= STEP;
    //       } else {
    //         scrollTop = targetOffsetTop;
    //       }
    //       document.body.scrollTop = scrollTop;
    //       document.documentElement.scrollTop = scrollTop;
    //       requestAnimationFrame(smoothUp);
    //     }
    //   }
    // },

    tip() {
      Toast({
        message: this.$t("Nav.Menu.UnderDevelopment"),
        position: "center",
        duration: 2000,
      });
    },

    languageFun(Languageval) {
      this.currentLanguage = Languageval;
      this.setLanguage(this.currentLanguage);
      localStorage.setItem("locale", this.currentLanguage);
      this.$i18n.locale = this.currentLanguage;
      this.shouMenu = false;
    },
    dropSDGsFun(MenuVal) {
      var ifExist = this.sdgsNavList.indexOf(MenuVal);
      if (ifExist > -1) {
        this.sdgsNavList.splice(ifExist, 1);
      } else {
        this.sdgsNavList.push(MenuVal);
      }
      // this.openSDGs = !this.openSDGs;
    },
    openMenu() {
      this.shouMenu = !this.shouMenu;
    },
    scrollToFun(index) {
      return;
      console.log(index);
      if (index == 5) {
        alert(this.$t("nav.tipPhone"));
        return;
      }
      this.$parent.scrollTo(index);
    },
  },
};
</script>

<style scoped lang="scss">
.phone_nav_box {
  position: absolute;
  top: 0;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 999;
}
.noBorder {
  border-bottom: none !important;
}
@media screen and (max-width: 767px) {
  .active_menu {
    // background: rgba(4, 18, 47, 1);
    transition: 0.2s;
    border-bottom: 1px solid rgba(0, 53, 107, 0.6);
  }
  .NarBarUlColor1 {
    .title_ {
      background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.4),
        rgba(0, 0, 0, 0)
      );
    }
    .menu {
      display: inline-flex;
      flex-direction: column;
      justify-content: space-around;
      height: 28px;
      span {
        width: 28px;
        height: 3px;
        display: block;
        transition-property: opacity transform top;
        transition-duration: 0.3s;
        background-color: #fff !important;
      }
      span:nth-child(2) {
        transition-duration: 0.1s;
      }
    }
    .iphone_nav_box {
      position: absolute !important;
      left: 0;
      right: 0;
      top: 60px;
      overflow-y: auto;
      padding: 10px 20px;
      z-index: 999;
      color: #fff;
      background: #00274e;
      padding-bottom: 0px;
      box-shadow: 2px 2px 5px rgb(15, 17, 36);
      .iphone_nav_box_ul {
        padding: 10px 0;
        .dropdown {
          // height: 40px;
          line-height: 46px;
          font-size: 18px;
          color: #fff;
          .a_href {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            border-bottom: 2px solid rgb(27, 68, 109);
            a {
              width: 100%;
              display: inline-block;
              color: #fff;
            }
          }

          .secondLevel {
            display: flex;
            flex-direction: column;
            li {
              line-height: 46px;
              padding-left: 16px;
              font-size: 16px;
              color: #ccc;
              border-bottom: 1px solid rgb(27, 68, 109);
            }
          }
        }
        .dropdown:last-child {
          border-bottom: none;
        }
      }
    }
  }
  .NarBarUlColor2 {
    .title_ {
      background: #fff;
    }
    .menu {
      display: inline-flex;
      flex-direction: column;
      justify-content: space-around;
      height: 28px;
      span {
        width: 28px;
        height: 3px;
        display: block;
        transition-property: opacity transform top;
        transition-duration: 0.3s;
        background-color: #00274e;
      }
      span:nth-child(2) {
        transition-duration: 0.1s;
      }
    }
    .iphone_nav_box {
      position: absolute !important;
      left: 0;
      right: 0;
      top: 60px;
      overflow-y: auto;
      padding: 10px 20px;
      z-index: 999;
      color: #333;
      background: #fff;
      padding-bottom: 0px;
      box-shadow: 2px 2px 5px #999;
      .iphone_nav_box_ul {
        padding: 10px 0;
        .dropdown {
          // height: 40px;
          line-height: 46px;
          font-size: 18px;
          color: #fff;
          .a_href {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            border-bottom: 2px solid #ccc;
            color: #000;
            a {
              width: 100%;
              display: inline-block;
              color: #000;
            }
          }

          .secondLevel {
            display: flex;
            flex-direction: column;
            li {
              line-height: 46px;
              padding-left: 16px;
              font-size: 16px;
              color: #333;
              border-bottom: 1px solid rgb(187, 190, 192);
            }
          }
        }
      }
    }
  }
  .title_ {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    transition: 0.2s;

    .logo_ {
      display: flex;
      flex-direction: row;
      .phone_logo0{
        height: 46px;
        margin-right: 10px;
        img {
          width: 100%;
        }
      }
      .phone_logo1 {
        width: 90px;
        height: 46px;
        margin-right: 10px;
        img {
          width: 100%;
        }
      }
      .phone_logo2 {
        width: 46px;
        height: 46px;
        margin-right: 10px;
        img {
          width: 100%;
        }
      }
      .logo_2 {
        width: 46px;
        height: 46px;
        img {
          width: 100%;
        }
      }
    }
    .menu {
      display: inline-flex;
      flex-direction: column;
      justify-content: space-around;
      height: 28px;
      span {
        width: 28px;
        height: 3px;
        display: block;
        transition-property: opacity transform top;
        transition-duration: 0.3s;
        background-color: #00274e;
      }
      span:nth-child(2) {
        transition-duration: 0.1s;
      }
    }
    .menu-closeable {
      position: relative;
      span:nth-child(1) {
        position: absolute;
        transform: rotateZ(45deg);
        top: 14px;
      }
      span:nth-child(2) {
        opacity: 0;
      }
      span:nth-child(3) {
        position: absolute;
        transform: rotateZ(-45deg);
        top: 14px;
      }
    }
  }
  .phone_nav_close_div {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    img {
      width: 110px;
      height: 60px;
    }
  }
}
.site-menu-sub {
  padding: 0px;
}
.sub-menu-enter-active,
.sub-menu-leave-active {
  transition: all 0.3s ease;
  // height: 100vh;
  // height: 250px; /* 这里70px为menu-one子菜单的高度 */
}
.sub-menu-enter,
.sub-menu-leave-to {
  opacity: 0;
  height: 0px;
}
</style>